import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

import { AlertModalOptionsModel } from './models/modal.alert.options';

@Component({
  selector   : 'wor-alert-modal',
  template: require('./modal.alert.component.html')
})
export class AlertModalComponent {

  @Input() options : AlertModalOptionsModel;

  constructor(
    public activeModal: NgbActiveModal
  ) {}
}
